import { Injectable } from "@angular/core";

@Injectable()
export class AsyncModalService {
    show: boolean = false;
    title: string = null;
    private promise: Promise<any>;
    private resolve: (value: string) => void;
    private reject: (value: string) => void;
    private isModalOpen: boolean = false;
    private delayResponse: number = null;
    showModal: () => void;
    closeModal: () => void;
    buttons: AsyncModalButton[];

    getModalResponse(
        title: string,
        buttons: AsyncModalButton[] = [{ label: "OK" }],
        delayResponse: number = null
    ) {
        this.delayResponse = delayResponse;
        this.isModalOpen = true;
        this.buttons = buttons;
        this.title = title;

        this.promise = new Promise<any>((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });

        this.showModal();

        return this.promise;
    }

    hide(value: string) {
        this.isModalOpen = false;

        setTimeout(() => {
            this.resolve(value);
        }, this.delayResponse);
    }

    close() {
        this.isModalOpen = false;
        this.closeModal();

        setTimeout(() => {
            this.reject(null);
        }, this.delayResponse);
    }

    isOpen(): boolean {
        return this.isModalOpen;
    }
}

export class AsyncModalButton {
    label: string;
    value?: any | AsyncModalButtonCallback;
    className?: string;
    closeOnClick?: boolean;
    data?: any;
    isHtml?: boolean = false;
    html?: string;
}

type AsyncModalButtonCallback = (button) => void;

export const ButtonPresets = {
    YesNo: [
        { label: "Yes", value: true },
        { label: "No", value: false, className: "btn-secondary" },
    ] as AsyncModalButton[],
    OkCancel: [
        { label: "OK", value: true },
        { label: "Cancel", value: false, className: "btn-secondary" },
    ] as AsyncModalButton[],
    Ok: [
        { label: "OK", value: true },
    ] as AsyncModalButton[],
    OKContinueCancel: [
        { label: "OK & Continue", value: true },
        { label: "Cancel", value: false, className: "btn-secondary" },
    ] as AsyncModalButton[],
};
